export default function creativePreview(PostCreativeTagData, RenderService) {
  const parseMessageEvent = (event) => {
    let data;

    if (typeof event.data === 'object') {
      data = event.data;
    } else if (typeof event.data === 'string') {
      if (event.data.indexOf('#moatframe#') >= 0) {
        return;
      }

      const json = event.data.replace(/^ima:\/\//, '');

      data = JSON.parse(json);
    }

    return data;
  };

  return {
    link(scope, element) {
      let firstRender = true;
      let renderedSite = null;

      const resizeListener = event => {
        let data;

        try {
          data = parseMessageEvent(event);
          if (!data) {
            return;
          }
          if (data.status === 'resize-frame') {
            let frame = document.getElementById('site-iframe');
            frame.style.height = `${data.height}px`;
            frame.style.overflow = 'visible';

            setTimeout(() => {
              window.$('#viewport').animate({ scrollTop: data.scrollTo });
            }, 500);
          }
        } catch (err) {
          console.log(err); // eslint-disable-line no-console
        }
      };

      window.addEventListener('message', resizeListener, false);

      const listener = event => {
        let data;

        try {
          data = parseMessageEvent(event);
          if (!data) {
            return;
          }
          if (data.status === 'ready') {
            window.dispatchEvent(
              new window.CustomEvent('str-nag-creative-update')
            );
            // clientjs
            element[0].contentWindow.postMessage(
              PostCreativeTagData.buildPostMessage(
                'creativeUpdate',
                RenderService.site.topScrollOffset
              ),
              '*'
            );

            // groundcontrol
            element[0].contentWindow.postMessage(
              PostCreativeTagData.buildPostMessage(
                'gc-render',
                RenderService.site.topScrollOffset,
                true //scroll to unit
              ),
              '*'
            );

            window.removeEventListener('message', listener, false);
          }
        } catch (err) {
          console.log(err); // eslint-disable-line no-console
        }
      };

      scope.$on('updatePreview', () => {
        if (!RenderService.site) {
          return;
        }

        if (renderedSite !== RenderService.site) {
          if (navigator.userAgent.match(/(iPhone|iPad)/)) {
            let frame = document.getElementById('site-iframe');
            frame.style.height = '100%';
          }

          window
            .$(element)
            .attr('src', `${RenderService.site.url}?waitForPostMessage=true`);

          renderedSite = RenderService.site;
          firstRender = true;
        }

        window.addEventListener('message', listener, false);

        if (firstRender) {
          firstRender = false;
        } else {
          // clientjs
          const message = JSON.stringify({ type: 'reloadAdV2' });
          element[0].contentWindow.postMessage(message, '*');

          // groundcontrol
          element[0].contentWindow.postMessage(
            PostCreativeTagData.buildPostMessage(
              'gc-render',
              RenderService.site.topScrollOffset
            ),
            '*'
          );
        }
      });
    }
  };
}

creativePreview.$inject = ['PostCreativeTagData', 'RenderService'];
